import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { FaEdit, FaTimes } from "react-icons/fa";
import "@github/relative-time-element";
import ScrollToTop from "../../../../components/scrollToTop/scrollToTop";
import { Helmet } from "react-helmet";
import ReactTimeAgo from "react-time-ago";
import "@formatjs/intl-relativetimeformat/polyfill";
import "@formatjs/intl-relativetimeformat/locale-data/es"; // Importa todos los locales que necesites (por ejemplo, 'es' para español)
import "./users_profile.css";
import DeletedUserProfile from "./deleted-users-profile";
import CreateUserProfile from "./create-users-profile";
import UpdateUserProfile from "./update-users-profile";
import TableControls from "../../../../components/tableControler/tableControler";

function PerfilesUsuario({ handleMenuClick }) {
  const [entries, setEntries] = useState([]);
  const [updateTrigger, setUpdateTrigger] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage, setDataPerPage] = useState(10);
  const [searchValue, setSearchValue] = useState("");
  const [showDeleted, setShowDeleted] = useState(false);
  const [showCreateUserProfile, setShowCreateUserProfile] = useState(false);
  const [showUpdateUserProfile, setShowUpdateUserProfile] = useState(false);
  const [selectedProfileId, setSelectedProfileId] = useState(null);

  const filteredData = searchValue
    ? entries.filter(
      (data) =>
        (data.id ? data.id.toString().toUpperCase() : "").includes(
          searchValue.toUpperCase()
        ) || data.name.toUpperCase().includes(searchValue.toUpperCase())
    )
    : entries;

  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentData = filteredData.slice(indexOfFirstData, indexOfLastData);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPageCount = Math.ceil(filteredData.length / dataPerPage);
  const pageNumbers = [];
  const maxPageNumbersToShow = 20;

  let startPage, endPage;
  if (totalPageCount <= maxPageNumbersToShow) {
    startPage = 1;
    endPage = totalPageCount;
  } else {
    startPage = Math.max(1, currentPage - Math.floor(maxPageNumbersToShow / 2));
    endPage = Math.min(totalPageCount, startPage + maxPageNumbersToShow - 1);

    if (endPage - startPage < maxPageNumbersToShow) {
      startPage = endPage - maxPageNumbersToShow + 1;
    }
  }

  for (let i = startPage; i <= endPage; i++) {
    pageNumbers.push(i);
  }

  const showEntries = (e) => {
    setDataPerPage(e.target.value);
  };

  const getEntries = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/user_profiles`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      if (res.data.code === 1) {
        setEntries(res.data.data);
      } else {
      }
    } catch (error) { 
      Swal.fire("Error", "Hubo un error al obtener los datos", "error");
    }
  };

  const deleteEntries = async (user) => {
    try {
      const result = await Swal.fire({
        title: "¿Estás seguro?",
        text: "¡No podrás revertir esto!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, eliminarlo",
        cancelButtonText: "No, cancelar",
        reverseButtons: true,
        buttonsStyling: true,
      });
      if (result.isConfirmed) {
        await axios.get(
          `${process.env.REACT_APP_URL_BACKEND}/api/v1/user_profiles/destroy/${user}`,
          {
            headers: {
              Authorization: `Bearer ${sessionStorage.getItem("token")}`,
            },
          }
        );
        Swal.fire("¡Eliminado!", "El registro ha sido eliminado.", "success");
        setEntries((prevEntries) => prevEntries.filter((entry) => entry.id !== user));
        setUpdateTrigger(!updateTrigger);
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire("Cancelado");
      }
    } catch (error) {
      Swal.fire("Error", "Hubo un error", "error");
    }
  };

  const findEntries = async (id) => {
    try {
      // Realizar la solicitud GET para obtener los datos del perfil de usuario
      const response = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/user_profiles/find/${id}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      const data = response.data.data;
      if (data.length > 0) {
        const userData = data[0]; // Obtener el primer objeto del array
        await Swal.fire({
          title: "Ver perfil de usuario",
          html: `<div class="form-grid" style="line-height: 1.6em; text-align: left;">
                          <div><strong>Nombre:</strong> ${userData.user}</div>
                      </div>`,
        });
      } else {
        Swal.fire(
          "Error",
          "No se encontraron datos para este perfil de usuario",
          "error"
        );
      }
    } catch (error) {
      // Manejar errores aquí
      console.log(error);
      Swal.fire(
        "Error",
        "Hubo un error al obtener los datos del perfil de usuario",
        "error"
      );
    }
  };

  const handleSearch = (value) => {
    setSearchValue(value.trim());
  }
  

  const handleCloseCreateUserProfile = () => {
    setShowCreateUserProfile(false);
    setUpdateTrigger(!updateTrigger); // Actualiza la lista de perfiles
  };

  const handleEditProfile = (id) => {
    setSelectedProfileId(id);
    setShowUpdateUserProfile(true);
  };

  useEffect(() => {
    getEntries();
  }, [updateTrigger]);

  return (
    <>
      <Helmet>
        <title>Horus | Perfil de Usuarios</title>
      </Helmet>
      <ScrollToTop />
      <div className="table-responsive">
        <div
          className="dataTables_wrapper dt-bootstrap4 no-footer container-fluid"
          id="datatables_wrapper"
        >
          {showCreateUserProfile ? (
            <>
              <div className="text-right mb-2">
                <button
                  className="btnn"
                  onClick={() => setShowCreateUserProfile(false)}
                >
                  Regresar
                </button>
              </div>
              <CreateUserProfile
                setShowCreateUserProfile={handleCloseCreateUserProfile}
                setUpdateTrigger={setUpdateTrigger}
                updateTrigger={updateTrigger}
              />
            </>
          ) : showUpdateUserProfile ? (
            <>
              <div className="text-right mb-2">
                <button
                  className="btnn"
                  onClick={() => setShowUpdateUserProfile(false)}
                >
                  Regresar
                </button>
              </div>
              <UpdateUserProfile
                profileId={selectedProfileId}
                setShowUpdateUserProfile={setShowUpdateUserProfile}
                setUpdateTrigger={setUpdateTrigger}
                updateTrigger={updateTrigger}
              />
            </>
          ) : (
            <>
              <div className="text-right mb-2 ">
                <button
                  className="btnn"
                  onClick={() => setShowDeleted(!showDeleted)}
                >
                  {showDeleted ? "Ver Activos" : "Ver Eliminados"}
                </button>
              </div>
              {showDeleted ? (
                <DeletedUserProfile
                  setUpdateTrigger={setUpdateTrigger}
                  updateTrigger={updateTrigger}
                />
              ) : (
                <>
                  <div className="text-right mb-4 ">
                    <button
                      className="btnn"
                      onClick={() => setShowCreateUserProfile(true)}
                    >
                      Añadir Perfil de usuarios
                    </button>
                  </div>
                  <TableControls
                    onSearch={handleSearch}
                    onEntriesChange={showEntries}
                    liveSearch={true}
                    debounceTime={500}
                  />

                  <div className="row">
                    <div className="col-sm-12">
                      <table
                        className="table table-inverse table-hover table-striped table-bordered dataTable no-footer"
                        role="grid"
                        aria-describedby="datatables_info"
                      >
                        <thead>
                          <tr role="row">
                            <th
                              className="sorting"
                              tabIndex={0}
                              aria-controls="datatables"
                              rowSpan={1}
                              colSpan={1}
                              style={{ width: "343.25px" }}
                            >
                              ID
                            </th>
                            <th
                              className="sorting"
                              tabIndex={0}
                              aria-controls="datatables"
                              rowSpan={1}
                              colSpan={1}
                              style={{ width: "343.25px" }}
                            >
                              Perfil
                            </th>
                            <th
                              className="sorting"
                              tabIndex={0}
                              aria-controls="datatables"
                              rowSpan={1}
                              colSpan={1}
                              style={{ width: "343.25px" }}
                            >
                              Creado
                            </th>
                            <th
                              className="sorting"
                              tabIndex={0}
                              aria-controls="datatables"
                              rowSpan={1}
                              colSpan={1}
                              style={{ width: "81.2031px" }}
                            >
                              Acciones
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentData.map((entry) => (
                            <tr key={entry.id}>
                              <td>{entry.id}</td>
                              <td>{entry.name}</td>
                              <td>
                                <ReactTimeAgo
                                  date={entry.created_at}
                                  locale="es"
                                />
                              </td>
                              <td>
                                <FaEdit
                                  className="editButton"
                                  onClick={() => handleEditProfile(entry.id)}
                                />
                                <FaTimes
                                  className="deleteButton"
                                  onClick={() => {
                                    deleteEntries(entry.id);
                                  }}
                                />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className="row">
                    <nav aria-label="Page navigation example">
                      <ul className="pagination">
                        <li className="page-item">
                          <button
                            className="page-link"
                            onClick={() => paginate(currentPage - 1)}
                            disabled={currentPage === 1}
                          >
                            Anterior
                          </button>
                        </li>
                        {pageNumbers.map((pageNumber) => (
                          <li className="page-item" key={pageNumber}>
                            <button
                              className="page-link"
                              onClick={() => paginate(pageNumber)}
                            >
                              {pageNumber}
                            </button>
                          </li>
                        ))}
                        <li className="page-item">
                          <button
                            className="page-link"
                            onClick={() => paginate(currentPage + 1)}
                            disabled={currentPage === pageNumbers.length}
                          >
                            Siguiente
                          </button>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default PerfilesUsuario;
